import { AccordionAnimatedContent } from '../../Accordion'

function EntityProfileHeaderBody({
  Content,
  Footer,
  InfoItems,
  contentClassName,
  contentProps,
  footerProps,
  infoItemsProps,
  isLoading,
  isOpen,
  sectionQaProps,
  withPageStickyTitle,
  onCloseModal,
  onSetFiles,
  onSetModal,
}) {
  const contentNode = (
    <>
      {InfoItems ? (
        <InfoItems {...infoItemsProps} isLoading={isLoading} />
      ) : null}

      {Content ? <Content {...contentProps} isLoading={isLoading} /> : null}

      {Footer ? (
        <Footer
          {...footerProps}
          isLoading={isLoading}
          onCloseModal={onCloseModal}
          onSetFiles={onSetFiles}
          onSetModal={onSetModal}
        />
      ) : null}
    </>
  )

  return (
    <AccordionAnimatedContent isOpen={isOpen}>
      {withPageStickyTitle ? (
        <div {...sectionQaProps} className={contentClassName}>
          {contentNode}
        </div>
      ) : (
        contentNode
      )}
    </AccordionAnimatedContent>
  )
}

export default EntityProfileHeaderBody
